import posthog from 'posthog-js'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST

let posthogInitialized = false
let userIdentified = false

/**
 * Initialize PostHog in cookieless mode.
 * Starts opted-out (cookieless): public pages get anonymous, privacy-preserving
 * analytics with no cookies or localStorage. On login, opt_in_capturing() switches
 * to full cookie mode. On logout, opt_out_capturing() returns to cookieless.
 */
export function initPostHog() {
  if (posthogInitialized || !posthogKey) return

  posthog.init(posthogKey, {
    api_host: posthogHost,
    ui_host: 'https://us.posthog.com',

    cookieless_mode: 'on_reject',
    opt_out_capturing_by_default: true,
    person_profiles: 'identified_only',

    capture_pageview: false,
    capture_pageleave: true,

    disable_session_recording: true,
    autocapture: true,
    persistence: 'localStorage+cookie',

    defaults: '2026-01-30',

    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '*',
    },
  })

  posthogInitialized = true
}

/**
 * Activate full tracking after user authenticates.
 * Legal basis: User agreed to ToS at signup (sign-in-wrap consent).
 *
 * @param {string} userId - Supabase Auth UUID
 * @param {object} userProperties - Person properties to set on identify
 */
export function identifyUser(userId, userProperties = {}) {
  if (!posthogInitialized || !userId) return

  posthog.opt_in_capturing()
  posthog.identify(userId, userProperties)
  posthog.startSessionRecording()

  userIdentified = true
}

/**
 * Deactivate full tracking on logout. Returns to cookieless mode.
 */
export function deidentifyUser() {
  if (!posthogInitialized) return

  posthog.stopSessionRecording()
  posthog.opt_out_capturing()
  posthog.reset()

  userIdentified = false
}

export function isPostHogReady() {
  return posthogInitialized
}

export function isUserIdentified() {
  return userIdentified
}

export { posthog }
